import React, { useState } from "react";
import CommonFreeTextInput from "../common/inputs/CommonFreeTextInput";
import InvoiceServicesList from "./InvoiceServicesList";
import { CreateServiceModal } from "../modal/createInvoice/CreateServiceModal";
import { useSelector } from "react-redux";
import OrderPaginationClone from "../order/OrderPaginationClone";
import { useLocation, useNavigate } from "react-router-dom";
import { URLdecode, URLencode } from "../../utils/url";

function InvoiceServicesTable() {
  const params = URLdecode();
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const { servicesMeta } = useSelector((state) => state.invoice);

  return (
    <div className="w-full flex flex-col">
      <CreateServiceModal open={createModal} setOpen={setCreateModal} />

      <div className="w-full justify-between items-center flex">
        <div className="w-full max-w-xl flex gap-3">
          <div className="flex flex-1">
            <CommonFreeTextInput
              placeholder="Search for service"
              value={search}
              onChange={(val) => setSearch(val)}
            />
          </div>
        </div>
        <div>
          <button
            className="py-3 px-10 rounded-md bg-primary1 text-white cursor-pointer"
            onClick={() => setCreateModal(true)}
          >
            <span className="font-medium  ">Create new service</span>
          </button>
        </div>
      </div>
      <InvoiceServicesList search={search} />
      <div>
        <OrderPaginationClone
          totalCount={servicesMeta?.total}
          perPage={Number(params?.limit || 10)}
          page={Number(params?.page || 1)}
          callback={(dat) => {
            if (
              Number(params?.page) === dat?.page &&
              Number(params?.limit) === dat?.perPage
            )
              return;
            navigate(
              `${location?.pathname}?${URLencode({
                ...params,
                page: dat?.page,
                limit: dat?.perPage,
              })}`,
              { replace: true }
            );
          }}
        />
      </div>
    </div>
  );
}

export default InvoiceServicesTable;
